import { Shield, FileCheck, HardHat, CreditCard, Server, ArrowRight, HeartPulse } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO = "/images/logo-circle.webp";
const LOGO_FULL = "/images/logo-full.webp";

const complianceItems = [
  { icon: Shield, title: "CMMC Compliance", desc: "Cybersecurity Maturity Model Certification for DoD-connected contracts.", link: "/resources/cmmc-compliance-guide-defense-contractors", linkText: "What is CMMC?" },
  { icon: FileCheck, title: "ISO 27001", desc: "International information security management standards.", link: "/resources/what-is-iso-27001", linkText: "What is ISO 27001?" },
  { icon: HeartPulse, title: "HIPAA Compliance", desc: "Privacy and security requirements for handling protected health information.", link: "/resources/hipaa-compliance-small-healthcare-practices", linkText: "What is HIPAA?" },
  { icon: HardHat, title: "OSHA Requirements", desc: "Digital record-keeping and safety system compliance.", link: "/resources/what-is-osha-digital-recordkeeping-compliance", linkText: "What is OSHA compliance?" },
  { icon: CreditCard, title: "Payment Fraud Prevention", desc: "Email authentication and financial controls against wire fraud." },
  { icon: Server, title: "BMS/IACS Security", desc: "Building management and industrial control system protection." },
];

function ComplianceCard({ item, index }) {
  return (
    <div data-testid={`compliance-card-${index}`} className={`text-center animate-fade-in-up stagger-${(index % 3) + 3}`}>
      <item.icon className="w-6 h-6 text-[#0077B3] mx-auto mb-3" />
      <h3 className="text-white font-semibold text-sm mb-1" style={{ fontFamily: "Outfit" }}>{item.title}</h3>
      <p className="text-[#c0cfe0] text-sm leading-relaxed">{item.desc}</p>
      {item.link && (
        <Link to={item.link} data-testid={`compliance-card-link-${index}`} className="inline-flex items-center gap-1 text-[#0077B3] text-xs font-medium mt-2 hover:text-white transition-colors">
          {item.linkText} <ArrowRight className="w-3 h-3" />
        </Link>
      )}
    </div>
  );
}

export default function Compliance() {
  return (
    <section id="compliance" data-testid="compliance-section" aria-label="Compliance and risk management" className="py-12 lg:py-18 bg-transparent relative overflow-hidden">
      <img src={LOGO} alt="" aria-hidden="true" loading="lazy" className="absolute -right-20 -bottom-16 w-[500px] h-[500px] object-contain opacity-[0.04] brightness-200 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="mb-10 text-center">
            <div className="relative flex items-center justify-center mb-10"><div className="absolute inset-0 flex items-center"><div className="w-full border-t border-white/10"></div></div><span className="relative bg-[#0f1d32]/80 backdrop-blur-sm px-8 py-1.5 rounded text-[#5cc0e8] text-xl font-extrabold uppercase tracking-[0.15em]">Compliance</span></div>
            <h2 data-testid="compliance-heading" className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mb-4 animate-fade-in-up stagger-1" style={{ fontFamily: "Outfit" }}>
              Compliance that supports growth, not just audits.
            </h2>
            <p className="text-[#c0cfe0] text-base max-w-2xl mx-auto animate-fade-in-up stagger-2">
              From CMMC to HIPAA to SOC 2, we build compliance into your systems so you’re always audit-ready - reducing exposure while keeping your business moving forward.
            </p>
        </div>

        <div className="border-t border-white/10 pt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          {complianceItems.map((item, i) => <ComplianceCard key={item.title} item={item} index={i} />)}
        </div>
      </div>
    </section>
  );
}
